// extracted by mini-css-extract-plugin
export default {"root":"MainInfo_root__2+FYX","listItem":"MainInfo_listItem__pLHjM","text":"MainInfo_text__CzAov","icon":"MainInfo_icon__Mtzzt"};